import { z } from "zod"
import { OrganizationTypeEnum } from "../../companies/dtos"

export const LaunchCampaignParamsSchema = z.object({
  id: z.string().transform(BigInt),
})

export const LaunchCampaignBodySchema = z.object({
  customerId: z.string().transform(BigInt),
})

export const GetCampaignHealthSchema = z.object({
  search: z
    .string()
    .optional()
    .transform((s) => (s ?? "").trim()),
  organizationTypes: z
    .union([z.string(), z.array(z.string())])
    .optional()
    .transform((value) => {
      if (!value) return []
      if (Array.isArray(value)) return value.flatMap((v) => v.split(","))
      return value.split(",")
    })
    .transform((values) => values.map((v) => v.trim()).filter(Boolean))
    .pipe(z.array(z.enum(OrganizationTypeEnum))),
})
